import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const arjDependenciesEmbedRoute: InvariantJiraRoute = {
	name: 'software-plan-dependencies-embed',
	path: '/jira/plans/:planId/scenarios/:scenarioId/dependencies/embed',
};
